<template>
  <div class="w-full h-full py-5 flex flex-col gap-5">
    <h1 class="text-lg lg:text-2xl font-semibold dark_text">
      Attendance Stats
    </h1>
    <div class="w-full overflow-scroll">
      <table class="min-w-full">
        <thead>
          <tr class="text-left bg-[#18469d] text whitespace-nowrap text-sm">
            <th class="px-6 py-3">S.No</th>
            <th class="px-6 py-3">Name</th>
            <th class="px-6 py-3">Course</th>
            <th class="px-6 py-3">Subject/Subject Code</th>
            <th class="px-6 py-3">Semester</th>
            <th class="px-6 py-3">Section</th>
            <th class="px-6 py-3">Student Count</th>
            <th class="px-6 py-3">Practical</th>
            <th class="px-6 py-3">Elective</th>
            <th class="px-6 py-3">No Of Session Taken</th>
            <th class="px-6 py-3">Session Taken In %</th>
            <th class="px-6 py-3">Average Attendance In %</th>
          </tr>
        </thead>
        <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
          <tr class="w-full">
            <td colspan="12" class="text-center py-6">
              <div class="flex items-center justify-center">
                <img src="@/assets/attendance/loading.gif" alt="" />
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <template v-if="attendance_list.length > 0">
            <tr
              v-for="(list, index) in attendance_list"
              :key="index"
              class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
            >
              <td class="px-6 py-3">{{ index + 1 }}</td>
              <td class="px-6 py-3">{{ list.name }}</td>
              <td class="px-6 py-3">{{ list.course }}</td>
              <td class="px-6 py-3 text-blues cursor-pointer">
                <router-link
                  :to="{
                    name: 'AttendanceStudentList',
                    params: {
                      subject_pk: list.subject_code,
                      timetable_pk: list.timetable_pk,
                      title: list.subject,
                      section: list.section,
                    },
                  }"
                >
                  {{ list.subject }} - {{ list.subject_code }}</router-link
                >
              </td>
              <td class="px-6 py-3">{{ list.semester }}</td>
              <td class="px-6 py-3">{{ list.section }}</td>
              <td class="px-6 py-3">{{ list.student_count }}</td>
              <td class="px-6 py-3">
                <span v-if="list.practical != null">{{ list.practical }}</span
                ><span v-else>---</span>
              </td>
              <td class="px-6 py-3">
                <span v-if="list.elective != null">{{ list.elective }}</span
                ><span v-else>---</span>
              </td>
              <td class="px-6 py-3">{{ list.no_of_session_taken }}</td>
              <td class="px-6 py-3">
                {{ roundOff(list.session_taken_in_percentarge) }}%
              </td>
              <td class="px-6 py-3">
                {{ roundOff(list.average_attendance_in_percentarge) }}%
              </td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="12" class="px-6 py-3 text-center">No Data Found</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="12" class="p-6 bg-[#18469d]"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      attendance_list: [],
      loading: true,
    };
  },
  async created() {
    await this.getAttendanceStats();
  },
  methods: {
    getAttendanceStats() {
      axios
        .get(
          `${process.env.VUE_APP_API_COMS}/faculty-admin/staff-attendance-stats/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((resp) => {
          console.log("resp", resp);
          if (resp.data.status == 200) {
            this.attendance_list = resp.data.data;
            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      });
    },
    roundOff(value) {
      const num = parseFloat(value);
      return isNaN(num) ? "0.00" : num.toFixed(2);
    },
  },
};
</script>

<style></style>
